import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Location, Readout } from 'src/api'
import { useApiInstance } from './useApiInstance'

export type LocationReadingType = 'cellularLocation' | 'gpsLocation'

interface LocationReadoutParams {
  timeFrom: string
  timeTo: string
}

interface RequestParams {
  sensorUniqueId: string
  locationType: LocationReadingType
  options?: Omit<UseMutationOptions<Location[], Error, LocationReadoutParams>, 'mutationKey' | 'mutationFn'>
}

export const useSensorLocationReadout = ({ sensorUniqueId, locationType, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<Location[], Error, LocationReadoutParams>(
    [Entities.SensorReadout, 'movement-detection', locationType],
    async ({ timeFrom, timeTo }: LocationReadoutParams) => {
      const { data } = await api.v1AdminSensorsUniqueIdReadoutGet(sensorUniqueId, timeFrom, timeTo, locationType)
      return (data as Readout)[locationType] || []
    },
    options
  )
}
